import React from 'react';
import { motion } from 'framer-motion';
import { Target, Zap, Calendar } from 'lucide-react';
const benefits = [{
  icon: Target,
  title: 'Guía Clara y Directa',
  description: 'Implementa cambios pequeños pero poderosos en tu vida diaria sin complicaciones ni tecnicismos.',
  color: 'text-[#22C55E]',
  bg: 'bg-[#22C55E]/10',
  border: 'border-[#22C55E]/20'
}, {
  icon: Zap,
  title: '5 Micro-Hábitos Esenciales',
  description: 'Hidratación inteligente, desayunos optimizados, movimiento diario, control de azúcares y rutina nocturna.',
  color: 'text-[#F59E0B]',
  bg: 'bg-[#F59E0B]/10',
  border: 'border-[#F59E0B]/20'
}, {
  icon: Calendar,
  title: 'Plan de 30 Días',
  description: 'Un plan paso a paso para consolidar tus nuevos hábitos y ver resultados reales en tu cuerpo y mente.',
  color: 'text-[#22C55E]',
  bg: 'bg-[#22C55E]/10',
  border: 'border-[#22C55E]/20'
}];
export function BenefitsSection() {
  return <section className="py-24 bg-[#0A0A0A] relative" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-4">
            Lo que obtendrás
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '100px'
        }} viewport={{
          once: true
        }} className="h-1 bg-[#22C55E] mx-auto rounded-full" data-id="element-5" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-6">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className={`p-8 rounded-2xl bg-gray-900/50 border ${benefit.border} hover:bg-gray-900 transition-colors duration-300`} data-id="element-7">
              <div className={`w-14 h-14 rounded-xl ${benefit.bg} flex items-center justify-center mb-6`} data-id="element-8">
                <benefit.icon className={`w-7 h-7 ${benefit.color}`} data-id="element-9" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-10">
                {benefit.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-11">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}